<script>
import options from "./CheckoutCart.options";
export default options;
</script>

<template>
    <article class="nti-checkout-cart">
        <article class="nti-checkout-line__item__mini-cart-header">
            <section class="nti-checkout-line__item__wrapper">
                <div class="nti-checkout-line__item__image-container__void"></div>
                <div class="nti-checkout-line__item__labels">
                    <span class="nti-webshop-checkout__mini-cart__label">{{ verifyLabel("itemLabel") }}</span>
                </div>
            </section>

            <section class="nti-checkout-line__item__info-container">
                <div class="nti-checkout-line__item__amount nti-checkout-line__item__info-block" :class="{ 'nti-checkout-line__item__info-block--scroll-margin-middle' : !scrollbarMargin}">
                    <span class="nti-webshop-checkout__mini-cart__label">{{ verifyLabel("quantityLabel") }}</span>
                </div>
                <div class="nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price" :class="{ 'nti-checkout-line__item__info-block--scroll-margin-nav' : scrollbarMargin}">
                    <span class="nti-webshop-checkout__mini-cart__label">{{ verifyLabel("priceLabel") }}</span>
                </div>
            </section>
        </article>

        <div class="nti-checkout-cart__container nti-checkout-cart__container--cart-line">
            <template v-for="data in cartItems" :key="data.code">
                <CartCheckoutLine :lineData="data" :itemCountInCart="itemCountInCart"/>
            </template>
        </div>
        <div class="nti-checkout-line__total__wrapper">
            <section class="nti-checkout-line__total">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum"> {{ cartTotalExclVatLabel }} </p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum">{{ cartTotalExclVat }}</p>
                    </div>
                </div>
            </section>
            <section class="nti-checkout-line__total" v-if="hasDiscount">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum"> {{ discountLabel }} - {{couponCode}} </p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum nti-checkout-line__total__sum--discount">-{{ discount }}</p>
                    </div>
                </div>
            </section>
            <!-- Hidden entirely when the fee is zero, matching the receipt page. A "Ekspeditionsgebyr
                 DKK 0,00" row is noise on a total the customer is reading for real numbers. -->
            <section class="nti-checkout-line__total" v-if="hasHandlingFee">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum">{{ handlingFeeLabel }}</p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum">{{ handlingFee }}</p>
                    </div>
                </div>
            </section>
            <section class="nti-checkout-line__total">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum"> {{ totalExVatLabel}} </p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum">{{ totalExVat }}</p>
                    </div>
                </div>
            </section>
            <section class="nti-checkout-line__total">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum"> {{ vatLabel}} </p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum">{{ vat }}</p>
                    </div>
                </div>
            </section>
            <section class="nti-checkout-line__total nti-checkout-line__total--vat">
                <div class="nti-checkout-line__total__container">
                    <div class="nti-checkout-line__total__labels">
                        <p class="nti-checkout-line__total__sum nti-checkout-line__total__sum--vat"> {{ totalIncVatLabel }} </p>
                    </div>
                    <div class="nti-checkout-line__total__price">
                        <p class="nti-checkout-line__total__sum nti-checkout-line__total__sum--vat">{{ totalIncVat }}</p>
                    </div>
                </div>
            </section>
        </div>
    </article>
</template>

